import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyDDZdDAf9YMFARpla7TzV_346SLiM6DAp8",
    authDomain: "hivits-app.firebaseapp.com",
    projectId: "hivits-app",
    storageBucket: "hivits-app.firebasestorage.app",
    messagingSenderId: "1020133198552",
    appId: "1:1020133198552:web:bcb09c036fb703a6dd25ad",
    measurementId: "G-16ND8MYHWP",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const functions = getFunctions(app);
const storage = getStorage(app);
const db = getFirestore(app);
const analytics = getAnalytics(app);

// connectFunctionsEmulator(functions, "localhost", 5001);
// connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
// connectFirestoreEmulator(db, "localhost", 8080);
// connectStorageEmulator(storage, "localhost", 9199);

auth.languageCode = "ko";
auth.useDeviceLanguage();

export default app;
export { auth, functions, storage, db };
